import _ from 'lodash';
import globalStore from '$$globalStore';
import app from '$$app';

function onTaskCustomFieldUpdated(event) {
  const customValuesForCommit = [];
  const projects = [];
  const projectColumns = globalStore.getters['columns/getProjectColumns'];
  const customValuesLoaded = globalStore.getters['columns/valuesLoaded'];
  const projectValuesMap = {};

  projectColumns.forEach(project => {
    projectValuesMap[project.id] = project.values;
  });

  const customValuesByTask = _.groupBy(event.data.customFields, 'taskId');

  Object.entries(customValuesByTask).forEach(([taskId, customValues]) => {
    const taskFromModel = globalStore.getters['tasksModel/getTask'](+taskId);

    if (!taskFromModel) {
      return;
    }

    if (projectValuesMap[taskFromModel.gantt_id] === null && !customValuesLoaded) {
      return;
    }

    const customFields = customValues.map(item => {
      let value = item.value;

      if (typeof value === 'boolean') {
        value = value ? 1 : 0;
      }

      return {
        customColumnId: +item.customFieldId,
        value,
      };
    });

    customValuesForCommit.push({
      taskId: +taskFromModel.id,
      ganttId: +taskFromModel.gantt_id,
      customFields,
    });
  });

  if (!_.isEmpty(customValuesForCommit)) {
    globalStore.commit('columns/updateUserCustomValues', { userCustomValues: customValuesForCommit, fromGantt: false }, { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.customFields.map(c => c.taskId),
    customFields: event.data.customFields,
    projects: [...new Set(projects)],
  });
}

export default onTaskCustomFieldUpdated;
